import type { ModulePermissions } from "@/services/api/user/types";

export interface MissionKitAccessUser {
  company_id?: string;
  email?: string;
  role?: string;
  permissions?: string[];
}

const ANI_INTERNAL_EMAIL_SUFFIX = "@ani.tech";

function isAniPlatformStaffUser(
  user: MissionKitAccessUser | null | undefined,
): boolean {
  if ((user?.company_id ?? "").toLowerCase() === "ani") {
    return true;
  }
  return (user?.email ?? "").toLowerCase().endsWith(ANI_INTERNAL_EMAIL_SUFFIX);
}

function hasAdminGrant(
  role: string | undefined,
  permissions: string[] | undefined,
): boolean {
  const normalizedRole = (role ?? "").toLowerCase();
  if (normalizedRole === "admin" || normalizedRole === "super_admin") {
    return true;
  }
  const perms = permissions ?? [];
  return perms.includes("*") || perms.includes("admin:*");
}

/** True when Ani platform staff may open MissionKit platform (MC entry). */
export function canAccessMissionKitPlatform(
  user: MissionKitAccessUser | null | undefined,
  modulePermissions?: Pick<ModulePermissions, "role" | "permissions"> | null,
): boolean {
  if (!isAniPlatformStaffUser(user)) {
    return false;
  }
  if (hasAdminGrant(user?.role, user?.permissions)) {
    return true;
  }
  if (modulePermissions) {
    return hasAdminGrant(modulePermissions.role, modulePermissions.permissions);
  }
  return false;
}
